export default __webpack_public_path__ + "static/media/img7.2b53659d.png";